import { render } from "./BlogTag.vue?vue&type=template&id=c89d8ede&scoped=true"
import script from "../js/blog-tag.js?vue&type=script&lang=js"
export * from "../js/blog-tag.js?vue&type=script&lang=js"

import "./BlogTag.vue?vue&type=style&index=0&id=c89d8ede&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89d8ede"]])

export default __exports__